import React from 'react';
import { Link } from 'react-router-dom';
import Swiper from 'swiper';
import blogPosts from '../data/data-post.json';
import "swiper/css";

const BlogTwo = () => {
    // Initialize Swiper after the component is mounted
    React.useEffect(() => {
        new Swiper('#blogSlider1', {
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                576: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                },
            },
            "spaceBetween": 20
        });
    }, []);

    return (
        <section className="bg-smoke overflow-hidden space-top" id="blog-sec">
            <div className="container shape-mockup-wrap">
                <div className="mb-30 text-center text-md-start">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-md-7">
                            <div className="title-area mb-md-0">
                                <span className="sub-title">Blog and Article</span>
                                <h2 className="sec-title">Travel Tips & Adventure Stories</h2>
                            </div>
                        </div>
                        <div className="col-md-auto">
                            <Link to="/blog" className="th-btn style4 th-icon">See More Articles</Link>
                        </div>
                    </div>
                </div>

                <div className="slider-area">
                    <div
                        className="swiper th-slider has-shadow"
                        id="blogSlider1"
                        data-slider-options='{"breakpoints":{"0":{"slidesPerView":1},"576":{"slidesPerView":"1"},"768":{"slidesPerView":"2"},"992":{"slidesPerView":"2"},"1200":{"slidesPerView":"3"}}}'
                    >
                        <div className="swiper-wrapper">
                            {blogPosts.slice(0, 6).map((post, index) => (
                                <div className="swiper-slide" key={index}>
                                    <div className="blog-box th-ani">
                                        <div className="blog-img global-img">
                                            <img src={`/assets/img/blog/${post.image}`} alt={post.title} />
                                        </div>
                                        <div className="blog-box_content">
                                            <div className="blog-meta">
                                                <Link className="author" to="/blog">
                                                    {post.publishDate}
                                                </Link>
                                                <Link to="/blog">{post.readTime}</Link>
                                            </div>
                                            <h3 className="box-title">
                                                <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                                            </h3>
                                            <Link to={`/blog/${post.slug}`} className="th-btn style4 th-icon">
                                                Read More
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="shape-mockup shape1 d-none d-xxl-block"
                    style={{
                        top: "14%",
                        right: "-13%",
                    }}
                >
                    <img src="/assets/img/shape/shape_1.png" alt="shape" />
                </div>
                <div className="shape-mockup shape2 d-none d-xl-block"
                    style={{
                        top: "25%",
                        right: "-12%",
                    }}
                >
                    <img src="/assets/img/shape/shape_2.png" alt="shape" />
                </div>
                <div className="shape-mockup shape3 d-none d-xxl-block"
                    style={{
                        top: "20%",
                        right: "-18%",
                    }}
                >
                    <img src="/assets/img/shape/shape_3.png" alt="shape" />
                </div>
            </div>
        </section>
    );
};

export default BlogTwo;

